import PdfFileIcon from 'svg/pdf-file.svg';
import CsvFileIcon from 'svg/csv-file.svg';
import PatientResults from 'modules/PatientResults';
export const REPORTS = [
    {
        id: 'basicPrint',
        Icon: PdfFileIcon,
        message: PatientResults.messages.buttons.standardDashboardReport
    },
    {
        id: 'bloodGlucoseConcentrationPrint',
        Icon: PdfFileIcon,
        message: PatientResults.messages.buttons.bloodSugarReport
    },
    {
        id: 'newCDABloodGlucoseConcentrationPrint',
        Icon: PdfFileIcon,
        message: PatientResults.messages.buttons.bloodSugarReport
    },
    {
        id: 'dailyLogPrint',
        Icon: PdfFileIcon,
        message: PatientResults.messages.buttons.bloodSugarDiaryReport
    },
    {
        id: 'newCDADailyLogReportPrint',
        Icon: PdfFileIcon,
        message: PatientResults.messages.buttons.bloodSugarDiaryReport
    },
    {
        id: 'agpBgmPrint',
        Icon: PdfFileIcon,
        message: PatientResults.messages.buttons.AgpBgmDashboardReport
    },
    {
        id: 'patientsBgDataReportPrint',
        Icon: CsvFileIcon,
        message: PatientResults.messages.buttons.PatientsBgData
    },
    {
        id: 'patientsGestationalReportPrint',
        Icon: PdfFileIcon,
        message: PatientResults.messages.headers.patientsGestationalReport
    }
];
export const NEW_CDA_REPORTS = [
    'newCDABloodGlucoseConcentrationPrint',
    'newCDADailyLogReportPrint'
];
